import { Prompts } from "@ant-design/x";
import ConversationItem from "../components/conversation";

import {
  CommentOutlined,
  FireOutlined,
  HeartOutlined,
  ReadOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import { type GetProp, Space } from "antd";

const renderTitle = (icon: React.ReactElement, title: string) => (
  <Space align="start">
    {icon}
    <span>{title}</span>
  </Space>
);

export const defaultConversationsItems: ConversationItem[] = [
  {
    key: "0",
    label: "什么是达康AI医生？",
  },
];

// 添加症状分类和具体症状
export const symptomCategories = [
  {
    label: "神经系统相关症状",
    value: "神经系统相关症状",
    children: [
      { label: "头晕", value: "头晕" },
      { label: "头痛", value: "头痛" },
      { label: "失眠障碍", value: "失眠障碍" },
    ]
  },
  {
    label: "五官系统相关症状",
    value: "五官系统相关症状",
    children: [
      { label: "听力障碍", value: "听力障碍" },
      { label: "耳鸣", value: "耳鸣" },
      { label: "眼睛红痛", value: "眼睛红痛" },
      { label: "鼻衄", value: "鼻衄" },
    ]
  },
  {
    label: "心血管系统相关症状",
    value: "心血管系统相关症状",
    children: [
      { label: "胸痛", value: "胸痛" },
      { label: "心悸", value: "心悸" },
    ]
  },
  {
    label: "呼吸系统相关症状",
    value: "呼吸系统相关症状",
    children: [
      { label: "咽痛", value: "咽痛" },
      { label: "咳嗽", value: "咳嗽" },
    ]
  },
  {
    label: "消化系统相关症状",
    value: "消化系统相关症状",
    children: [
      { label: "腹泻", value: "腹泻" },
      { label: "腹痛", value: "腹痛" },
      { label: "恶心呕吐", value: "恶心呕吐" },
      { label: "便血", value: "便血" },
      { label: "便秘", value: "便秘" },
      { label: "成人消化不良", value: "成人消化不良" },
    ]
  },
  {
    label: "泌尿生殖系统相关症状",
    value: "泌尿生殖系统相关症状",
    children: [
      { label: "血尿", value: "血尿" },
      { label: "排尿异常", value: "排尿异常" },
      { label: "异常子宫出血", value: "异常子宫出血" },
      { label: "阴道分泌物异常", value: "阴道分泌物异常" },
    ]
  },
  {
    label: "四肢关节相关症状",
    value: "四肢关节相关症状",
    children: [
      { label: "关节痛", value: "关节痛" },
      { label: "颈部疼痛", value: "颈部疼痛" },
      { label: "背痛", value: "背痛" },
      { label: "腰痛", value: "腰痛" },
      { label: "腿痛/膝关节痛", value: "腿痛/膝关节痛" },
      { label: "行走困难", value: "行走困难" },
      { label: "髋部/臀部疼痛", value: "髋部/臀部疼痛" },
    ]
  },
  {
    label: "慢性非传染性疾病",
    value: "慢性非传染性疾病",
    children: [
      { label: "2型糖尿病(复诊)", value: "2型糖尿病(复诊)" },
      { label: "高血压病(复诊)", value: "高血压病(复诊)" },
    ]
  },
  {
    label: "全身症状",
    value: "全身症状",
    children: [
      { label: "头晕", value: "头晕" },
      { label: "体表肿物", value: "体表肿物" },
      { label: "婴儿哭闹", value: "婴儿哭闹" },
      { label: "水肿", value: "水肿" },
      { label: "体重增加", value: "体重增加" },
      { label: "疲劳", value: "疲劳" },
      { label: "发热", value: "发热" },
    ]
  },
];

export const placeholderPromptsItems: GetProp<typeof Prompts, "items"> = [
  {
    key: "1",
    label: renderTitle(
      <FireOutlined style={{ color: "#FF4D4F" }} />,
      "热门问题"
    ),
    description: "热门问诊问题",
    children: [
      {
        key: "1-1",
        description: `冬季皮肤太干燥`,
      },
      {
        key: "1-2",
        description: `睡眠不好怎么办`,
      },
      {
        key: "1-3",
        description: `口干舌燥怎么办`,
      },
    ],
  },
  {
    key: "2",
    label: renderTitle(
      <ReadOutlined style={{ color: "#1890FF" }} />,
      "养生指南"
    ),
    description: "达康养生指南",
    children: [
      {
        key: "2-1",
        icon: <HeartOutlined />,
        description: `冬天如何养生`,
      },
      {
        key: "2-2",
        icon: <SmileOutlined />,
        description: `春季如何养生`,
      },
      {
        key: "2-3",
        icon: <CommentOutlined />,
        description: `如何保养皮肤`,
      },
    ],
  },
];

export const senderPromptsItems: GetProp<typeof Prompts, "items"> = [

];